import { all, call, put, takeLatest } from "redux-saga/effects";
import { prepareLoanForm } from "./reducer";
import actions from "./actions";
import { submitForm, submitFormManageRepayments } from "../utility/shared";
import { getCardDetails } from "../../services/clientApi";
import { isFeatureFlagOn } from "@utils/helpers/featureFlagHelper";

function* loanForm(action) {
  const { payload } = action;
  const { values, endpoint, formId } = payload;

  yield put(actions.postLoanFormStart());

  const loanFormPost = prepareLoanForm({ values });

  if (isFeatureFlagOn('featureEziDebit')) {
    yield call(submitFormManageRepayments, endpoint, loanFormPost.values, actions, formId);
  } else {
    yield call(submitForm, endpoint, loanFormPost.values, actions);
  }
}

function* getPartialCardData(accountNumber) {
  try {
    yield put(actions.cardIsFetching());
    const response = yield call(getCardDetails, accountNumber.payload);
    const { data : { code, value } } = response;

    if (code === 200) {
      yield put(actions.getPaymentCardDataSuccess(value));
      yield put(actions.cardOnFile(true));
    } else {
      yield put(actions.getPaymentCardDataFailed(true));
      if (code === 404) {
        yield put(actions.cardOnFile(false));
      }
    }
  } catch (e) {
    yield put(actions.getPaymentCardDataFailed(true));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.MANAGE_REPAYMENT_POST_APPLICATION, loanForm),
    takeLatest(actions.MANAGE_REPAYMENT_GET_PAYMENT_CARD_DATA, getPartialCardData),
  ]);
}